export default {
	drawer:false,
	mini:true,
	miniWidth:56,
	active:null
}